/* eslint-disable @typescript-eslint/camelcase */

import Vue from "vue";
import mime from "mime-types";
import { BlobServiceClient } from "@azure/storage-blob";
import { CallLogType } from "./store/modules/enums";

export async function uploadCallFile(
  publicId: string,
  file: File,
  logTypeId: CallLogType
): Promise<number> {
  // GET FILE SLOT
  const response = await Vue.axios.post("callcenter/call/chat/file/slot");
  const { storageId, storageUri } = response.data;
  // UPLOAD FILE TO SLOT
  const blobServiceClient = new BlobServiceClient(storageUri);
  const containerName = "";
  const containerClient = blobServiceClient.getContainerClient(containerName);
  const blockBlobClient = containerClient.getBlockBlobClient(storageId);
  const blobHTTPHeaders = {
    blobContentType: mime.lookup(file.name) || "application/octet-stream",
    blobContentDisposition: "filename=" + file.name,
  };
  const metadata = {
    file_name: file.name,
    file_size: String(file.size),
  };
  await blockBlobClient.uploadData(file, {
    blobHTTPHeaders,
    metadata,
    blockSize: 4 * 1024 * 1024,
    concurrency: 20,
    onProgress: (ev) => console.log(ev),
  });
  // SAVE FILE INFO TO DB
  const params = new FormData();
  params.append("publicId", publicId);
  params.append("fileName", file.name);
  params.append("fileSize", file.size.toString());
  params.append("contentType", blobHTTPHeaders.blobContentType);
  params.append("storageId", storageId);
  params.append("logTypeId", logTypeId);
  //
  const { data } = await Vue.axios.post(
    "callcenter/call/chat/file/save",
    params
  );
  const { id } = data;
  // RETURN NEW FILE ID
  return id;
  //
}

export async function archiveCallFile(id: number) {
  // SET PARAMS
  const params = new FormData();
  params.append("id", id.toString());
  //
  await Vue.axios.post("callcenter/call/chat/file/archive", params);
  //
}

export function callFileUrl(storageId: string): string {
  const { hostname } = window.location;
  let url = "https://wmcallcenter.blob.core.windows.net/";
  if (hostname.includes("localhost") || hostname.includes(".dev.")) {
    url += "dev/";
  } else if (hostname.includes(".qa.")) {
    url += "quality/";
  } else if (hostname.includes(".uat.")) {
    url += "uat/";
  } else {
    url += "prod/";
  }
  url += storageId;
  return url;
}
